import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const moratoriumMutations: UpdatesConfig['Mutation'] = {
  moratoriumCreate: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('moratoriums', cache);
  },
};

export default moratoriumMutations;
